module.exports = __webpack_public_path__ + "img/img55.4ec57004.png";